<template>
  <div>

    <b-card no-body >
      <b-row class="m-1">
        <!-- <b-col lg="2">
          <b-form-group
              label="."
              label-for="fecha_inicio"
          >
          <b-button
              title="Actualizar Registros"
              variant="gradient-primary"
              class="mr-1"
              @click="rellenarVacios"
              :disabled="loadingASI"
          >
            <span v-if="loadingASI">Actualizando Datos &emsp; <font-awesome-icon icon="fa-solid fa-arrows-rotate" spin/></span>
            <span v-else>Actualizar Datos &emsp; <font-awesome-icon icon="fa-solid fa-arrows-rotate"/></span>

          </b-button>
          </b-form-group>
        </b-col> -->
        <b-col lg="1">
          <b-form-group
              label="."
              label-for="actualizar_etl"
          >
            <b-button
                variant="gradient-primary"
                id="btn_back"
                block
                @click="descargarMasiva()"
                :disabled="estado_btn_descargamasiva"
                v-b-tooltip.hover="'Descargar Registros'"
            >
              <font-awesome-icon icon="fa-solid fa-download"/>
            </b-button>
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group
              label="."
              label-for="actualizar_etl"
          >
            <b-button
                variant="gradient-primary"
                id="btn_back"
                block
                @click="actualizarETL"
            >
              <span v-if="cargandoETL" style="font-size:13px">Actualizando Datos...&emsp; <font-awesome-icon icon="fa-solid fa-arrows-rotate"/></span>
              <span v-else style="font-size:13px">Actualizar Datos &emsp; <font-awesome-icon icon="fa-solid fa-arrows-rotate"/></span>
              <!-- <b class="font-medium-1">Filtrar &emsp;</b>
              <feather-icon
                  icon="FilterIcon"
                  size="16"
              /> -->
            </b-button>
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group
              label="Emisión Desde"
              label-for="fecha_inicio"
          >
            <b-form-datepicker
                id="fecha_inicio"
                v-model="fecha_inicio"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                :hide-header=true
                start-weekday="1"
                v-bind="labels || {}"
                today-button
                reset-button
                close-button
                name="fecha_inicio"
            />
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group
              label="Emisión Hasta"
              label-for="fecha_fin"
          >
              <b-form-datepicker
                  id="fecha_fin"
                  v-model="fecha_fin"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  :hide-header=true
                  start-weekday="1"
                  v-bind="labels || {}"
                  today-button
                  reset-button
                  close-button
                  name="fecha_fin"
              />
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group
              label="N° de Comprobante"
              label-for="evento"
          >
            <b-input-group size="md">
                <b-form-input
                  id="evento"
                  v-model="evento"
                  name="evento"
                />
                <b-input-group-append>
                  <b-button
                      variant="gradient-secondary"
                      :disabled="!evento"
                      @click="itemsFiltro = items; evento = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="2">
          <b-form-group
              label="."
              label-for="fecha_inicio"
          >
            <b-button
                variant="gradient-primary"
                id="btn_back"
                block
                @click="traerFacturas"
            >
              <span style="font-size:15px">Filtrar &emsp;</span>
              <feather-icon
                  icon="FilterIcon"
                  size="16"
              />
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
          hover
          responsive
          class="position-relative"

          :per-page="perPage"
          :current-page="currentPage"

          :items="items"
          :fields="fields"
          :filter="evento"
          :filter-included-fields="filterOn"

          @filtered="cPaginacion"

          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <!-- Agregar checkbox en el header -->
        <template #head(check)="data">
            <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"/>
        </template>

        <!-- Agregar una columna para el checkbox en las filas -->
        <template #cell(check)="data">
            <b-form-checkbox
                :value="data.item"
                v-model="selected"
                class="custom-control-success"
                @change="validarCheckSeleccionados"
            />
        </template>


        <template #cell(case)="data">
          <b-badge variant="success">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                size="16"
                class="mr-1"
                @click="abrirModalEditar(data.item)"
            />
            <b-tooltip
                title="Editar registro"
                :target="`btn_${data.item.id}_editar`"
            />
          </div>
        </template>
<!--
        <template #cell(pdf)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.factura}_editar`"
                size="16"
                class="mx-1"
                @click="generarPdf(data.item)"
                v-b-tooltip.hover="'Descargar PDF'"
            />
          </div>
        </template> -->

        <!-- <template #cell(firma)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.id}_ver`"
                icon="ImageIcon"
                size="16"
                class="text-info mx-1"
                @click="verFirma(data.item.firma)"
            />
          </div>
        </template> -->


        <template #cell(pdf)="data">
          <div class="text-nowrap" >
            <b-img
                v-b-tooltip.hover
                title="Descargar PDF"
                :src="require('@/assets/images/icons/pdf1.png')"
                height="auto"
                width="30"
                @click="generarPdf(data.item)"
            />

          </div>
        </template>
        <template #cell(con_evaluador)="data">
          <span class="text-nowrap">{{data.value.nombres}} {{data.value.apellidos}}</span>
        </template>
        <template #cell(emision)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value.split('-')).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
        </template>
        <template #cell(modified)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value.split('/')).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
        </template>
      </b-table>
    </b-card>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
      id="modal-editar"
      ref="modal-editar"
      v-model="mostrarModalEditar"
      no-close-on-esc
      no-close-on-backdrop
      cancel-variant="secondary"
      ok-title="Editar"
      cancel-title="Cancelar"
      :cancel-disabled="loadingEditar"
      :ok-disabled="loadingEditar"
      size="lg"
      centered
      title="Editar Valor Unitario"
      @ok="okModalEditar"
    >
      <div v-if="loadingRegistrar"  align="center">
        <p>Editando registro ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <div v-else>
        <validation-observer ref="editarCategoria">
          <b-form autocomplete="off" @submit.prevent="editarRegistro">
            INFORMACIÓN
            <br>
            <br>
            <b-row>

              <b-col lg="4">
                <b-form-group
                    label="Comprobante"
                    label-for="valor_unitario_f"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="comprobante_f"
                      vid="comprobante_f"
                      rules="required"
                  >
                    <b-form-input
                        id="comprobante_f"
                        name="comprobante_f"
                        v-model="comprobante_f"
                        :state="errors.length > 0 ? false:null"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="Estado del Documento"
                    label-for="estado_doc_f"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="estado_doc_f"
                      vid="estado_doc_f"
                      rules="required"
                  >
                    <b-form-input
                        id="estado_doc_f"
                        name="estado_doc_f"
                        v-model="estado_doc_f"
                        :state="errors.length > 0 ? false:null"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="Factura"
                    label-for="factura_f"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="factura_f"
                      vid="factura_f"
                      rules="required"
                  >
                    <b-form-input
                        id="factura_f"
                        name="factura_f"
                        v-model="factura_f"
                        :state="errors.length > 0 ? false:null"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="12"  v-for="(x,index) in detalle_des_productos" :key="index">
                CANTIDAD: {{x['cantidad_entregada_final'] }}&nbsp;&nbsp; - &nbsp;&nbsp; DETALLE: {{ x['denominacion_tipo_unidad'] }} {{ x['denominacion_tipo_caja'] }} {{ x['peso_neto_unitario'] }} KG
                {{ x['cultivo'] }} {{ x['denominacion_tipo_fruta'] }}

                <div :id="'detalle_producto'+(index+1)" style="display: none;">{{ x['denominacion_tipo_unidad'] }} {{ x['denominacion_tipo_caja'] }} {{ x['peso_neto_unitario'] }} KG
                {{ x['cultivo'] }} {{ x['denominacion_tipo_fruta'] }} </div>
                <div :id="'cantidad_por_detalles'+(index+1)" style="display: none;">{{ x['cantidad_entregada_final'] }}</div>
                <div :id="'precio_neto_unitario'+(index+1)" style="display: none;">{{ x['precio_neto_unitario'] }}</div>
                <div :id="'variedad'+(index+1)" style="display: none;">{{ x['variedad'] }}</div>
                <div :id="'numero_material'+(index+1)" style="display: none;">{{ x['numero_material'] }}</div>
                <b-form-group
                    :label="'Valor Unitario '+(index+1)"
                    :label-for="'valor_unitario'+(index+1)"
                >
                <!-- <b-form-group
                    :label="'Cantidad: '+ x['cant_fab']"
                    :label-for="'valor_unitario'+(index+1)"
                > -->

                  <validation-provider
                      #default="{ errors }"
                      :name="'valor_unitario'+(index+1)"
                      :vid="'valor_unitario'+(index+1)"
                      rules="required"
                  >
                    <b-form-input
                        :id="'valor_unitario'+(index+1)"
                        :name="'valor_unitario'+(index+1)"
                        :v-model="'valor_unitario'+(index+1)"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
<!--
              <b-col lg="12">
                CAJA CARTON 2.50 KG - BULK ARANDANO FRESCO
                <b-form-group
                    label="Valor Unitario II"
                    label-for="valor_unitario"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="valor_unitario"
                      vid="valor_unitario"
                      rules="required"
                  >
                    <b-form-input
                        id="valor_unitario"
                        name="valor_unitario"
                        v-model="valor_unitario"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->

              <!-- <b-col lg="12">
                CAJA CARTON 2.50 KG - BULK ARANDANO FRESCO
                <b-form-group
                    label="Valor Unitario II"
                    label-for="valor_unitario"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="valor_unitario"
                      vid="valor_unitario"
                      rules="required"
                  >
                    <b-form-input
                        id="valor_unitario"
                        name="valor_unitario"
                        v-model="valor_unitario"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="12">
                CAJA DE CARTON 1.50 KG - 4.4 OZ ARANDANO FRESCO
                <b-form-group
                    label="Valor Unitario III"
                    label-for="valor_unitario"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="valor_unitario"
                      vid="valor_unitario"
                      rules="required"
                  >
                    <b-form-input
                        id="valor_unitario"
                        name="valor_unitario"
                        v-model="valor_unitario"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import { BFormDatepicker, BBadge, BImg, BButton, BCard,BFormCheckbox, BCardBody,  BForm, BFormGroup, BFormInput, BFormSelect, BModal, BPagination, BSpinner, BTable, BRow, BCol, BDropdownDivider, BTooltip, VBTooltip, BInputGroupAppend, BInputGroup, } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'


let digitos_fecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
let fecha_hoy=new Date()
//Formateo fecha_hoy
let fecha_actual = fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
fecha_actual=fecha_actual[2]+'-'+fecha_actual[1]+'-'+fecha_actual[0]
//Resto los días a la fecha actual
let dias_a_restar = 32;
fecha_hoy.setDate(fecha_hoy.getDate() - dias_a_restar);
let fecha_desde=fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
fecha_desde=fecha_desde[2]+'-'+fecha_desde[1]+'-'+fecha_desde[0]

export default {
  components: {
    BFormDatepicker,
    BCard,
    BImg,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormCheckbox,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,

  vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    // fecha_inicio: '2023-01-01',
    id_user: JSON.parse(localStorage.getItem('userData')).id,
    cargandoETL:'',
    // fecha_inicio:'2023-07-26',
    fecha_inicio:fecha_desde,
    fecha_fin: fecha_actual,
    evento: null,
    loading: false,
    mostrarModalEditar: false,
    loading2: false,
    loadingRegistrar: false,
    valor_unitario:'',
    items: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    filter: null,
    detalle_des_productos:[],
    tipo_doc:'Factura',
    selected:[],
    estado_btn_descargamasiva:true,
    filterOn: [],
    selectAll: false,
    fields: [
        /*
        {
          key: 'estado',
          label: 'estado',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },

        {
          key: 'fecha_hora',
          label: 'Fecha y Hora de Entrega',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        */

      {
          key: 'check',
          label: ' ',
          class: 'text-nowrap text-center',
      },

      {
        key: 'pdf',
        label: 'PDF',
        tdClass: 'alinear-una-sola-linea  text-center',
      },
      {
        key: 'acciones',
        label: '#',
        thClass: 'text-center py-0 alinear-medioA',
        class: 'px-0 text-center',
      },
      {
        key: 'nombre_emp',
        label: 'sociedad',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'ref_contenedor',
        label: 'referencia',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'customer',
        label: 'cliente',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'responsable_pago', // Aqui va si es UK o UE
        label: 'responsable_pago',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'tipo',
        label: 'tipo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'num_doc_referencia',
        label: 'comprobante',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'fecha_factura',
        label: 'fecha_emision',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'moneda_doc_comercial',
        label: 'moneda',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'importe',
        label: 'importe',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-right',
      },
      {
        key: 'case',
        label: 'estado',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
    ],
    // status: [
    //   {
    //     1: 'Pendiente',
    //     4: 'Devolución',
    //     7: 'Descuento',
    //   },
    //   {
    //     1: 'light-warning',
    //     4: 'light-success',
    //     7: 'light-danger',
    //   }
    // ],


    fotosFirma: "",
    estadoModalFirma:false,
    infoModal: {
      title: '',
      boton: '',
    },

    loadingEditar: false,
    estadoModalEditar: false,
    id_editar: 0,
    id_evaluador: 0,
    dni: null,
    nombres: null,
    cargo: null,
    packing: null,
    area: null,
    labor: null,
    codigo: null,
    valor_unitario1:'',
    valor_unitario2:'',
    valor_unitario3:'',
    valor_unitario4:'',
    valor_unitario5:'',
    valor_unitario6:'',
    observacion: null,
    estado: null,

    // estados: [
    //   {value: '1', text: "Pendiente"},
    //   {value: '4', text: "Devolución"},
    //   {value: '7', text: "Descuento"},
    // ],

    labels: {
      labelPrevDecade: 'Década anterior',
      labelPrevYear: 'Año anterior',
      labelPrevMonth: 'Mes anterior',
      labelCurrentMonth: 'Mes actual',
      labelNextMonth: 'Mes siguiente',
      labelNextYear: 'Año siguiente',
      labelNextDecade: 'Década siguiente',
      labelToday: 'Hoy',
      labelSelected: 'Fecha seleccionada',
      labelNoDateSelected: 'Seleccione fecha',
      labelCalendar: 'Calendario',
      labelNav: 'Navegación por calendario',
      labelHelp: 'Use las teclas de flecha para navegar por el calendario',
      labelTodayButton: 'Hoy',
      labelResetButton: 'Borrar',
      labelCloseButton: 'Cerrar',
    },

    // validation rules
    required,
  }),
  computed: {},
  mounted() {
    this.traerFacturas();
    localize("es");
  },

  methods: {

    closeSwal(swalInstance) {
        // Cerrar SweetAlert utilizando la instancia almacenada
        if (swalInstance) {
            swalInstance.close();
        }
    },

    toggleSelectAll() {
        if (this.selectAll == true){
            for (let x of this.items){
                this.selected.push(x)
                this.estado_btn_descargamasiva=false
            }
        }else{
            this.selected=[]
            this.estado_btn_descargamasiva=true
        }
        // console.log("SELECCIONADOS:")
        // console.log(this.selected)
    },

    onCheckboxChange() {
        this.selectAll = this.items_detalle.every(item => item.selected);
    },

    descargarMasiva() {
        const yo=this
        // this.autoClose();

        // Almacenar la instancia de SweetAlert en una variable
        const swalInstance = this.$swal({
            title: 'Descargando...',
            icon: 'info',
            html: 'Por favor espere',
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
        });


        // yo.estadoModalRespuesta=true
        var datosg_facturas=yo.selected

        const data=JSON.stringify(
            {
            'datosg_facturas': datosg_facturas,
            }
        )

        const config={
            method:'post',
            url:'/comex/holdco/generarPdfDeFacturaMasivo/pdf/',
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'arraybuffer',
            data : data
        }

        axiosIns(config)
            .then(function(response){
            if(response.status===200){
                // Crea una URL para el archivo ZIP recibido
                const zip_url = URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));

                // Crea un enlace de descarga
                const link = document.createElement('a');
                link.href = zip_url;
                link.setAttribute('download', 'archivos_pdf.zip'); // Nombre del archivo ZIP

                // Agrega el enlace al cuerpo del documento y haz clic para descargar
                document.body.appendChild(link);
                link.click();

                yo.closeSwal(swalInstance);
            }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // yo.estadoModalRespuesta=false
            });

    },

    validarCheckSeleccionados(){
      if( this.selected.length == 0 ){
          this.estado_btn_descargamasiva=true
      }else{
          this.estado_btn_descargamasiva=false
      }
    },

    actualizarETL(){
      const yo=this
      yo.cargandoETL=true
      const data=JSON.stringify({
        'fecha_fin':fecha_actual,
      })

      const config={
        method:'POST',
        url:'/comex/holdco/actualizaretl/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data:data,
      }

      axiosIns(config)
        .then(function(response){
          // console.log(response)
          if(response.status === 200){
            if(response.data['data']['resultado']=='EJECUCION SATISFACTORIA'){
              // console.log("Se actualizó correctamente")
              yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Actualización completada',
                        icon: 'CheckIcon',
                        text: 'La actualización se realizó con éxito.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
            }
          }
        })

        .catch(function (error) {
          console.log(error);
          yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Actualización fallida',
                        icon: 'XIcon',
                        text: 'Ocurrió un error en la actualización',
                        variant: 'danger',
                      },
                    },
                    {
                      position: 'top-center',
                    })
        })
        .finally(function (){
          yo.cargandoETL=false
          yo.traerFacturas();
        });

    },

    traerFacturas(){
      const yo = this

      yo.loading = true
      if(yo.evento==''){
        // console.log("ENTRO")
      }
      const data = JSON.stringify({
        'fecha_inicio':yo.fecha_inicio,
        'fecha_fin':yo.fecha_fin,
        'n_comprobante':yo.evento
      })

      const config = {
        method: 'post',
        url: '/comex/holdco/facturas/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data : data
      };

      axiosIns(config)
        .then(function (response) {
          if(response.status === 200){
            yo.items=response.data['response']
            yo.totalRows = yo.items.length
            // console.log(response)
            // console.log(response.data['response'])

            // for (let i = 0; i < arrayMultidimensional.length; i++) {
            //   arrayMultidimensional[i].nuevaClave = 'nuevoValor';
            // }

            for (let i = 0; i < yo.items.length; i++) {
              yo.items[i].tipo = "Factura";
            }


            // yo.mostrarNotificacion('¡Registro Guardado!', 'CheckIcon', 'La importación se realizó con éxito', 'success', 5000)
          }

        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function (){
          yo.loading = false
          yo.selected=[]
          yo.selectAll=false
        });
    },

    generarPdf(datos){
      const yo=this
      var datosg_factura=[];
      datosg_factura=datos
      const n_factura=datos['num_doc_referencia']
      const cliente=datos['customer']
      const referencia=datos['ref_contenedor']
      const div_palabras = cliente.split(" ");
      const primerasTresPalabras = div_palabras.slice(0, 3).join(" ");
      const nombre_archivo='HOLDCO '+n_factura.toString()+' '+primerasTresPalabras.toString()+ ' '+ referencia.toString()
      // console.log(nombre_archivo)
      // console.log(datos)
      const data=JSON.stringify(
        {
          'datosg_factura':datosg_factura,
          // 'rango_fecha':yo.dateRange
        }
      )

      const config={
        method:'post',
        url:'/comex/holdco/facturas/pdf/',
        headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
      }

      axiosIns(config)
        .then(function(response){
          if(response.status===200){
            // console.log("RSPTA GOOD")
            var pdf_url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            // window.open(pdf_url);
            const link = document.createElement('a');
            link.href = pdf_url;
            link.setAttribute('download', nombre_archivo+'.pdf');
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loadingExcel = false
        });

    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    abrirModalEditar(datos){

      this.detalle_des_productos=[];

      this.mostrarModalEditar = true
      this.comprobante_f=datos['num_doc_referencia']
      this.estado_doc_f=datos['case']
      this.factura_f=datos['factura']

      //Consulto en COMEX para traer el detalle:

      const yo=this
      var datosg_factura=[];
      datosg_factura=datos

      const data=JSON.stringify(
        {
          'datosg_factura':datosg_factura,
          // 'rango_fecha':yo.dateRange
        }
      )

      const config={
        method:'post',
        url:'/comex/holco/factura/detalle/',
        headers: {
            'Content-Type': 'application/json'
          },
          data : data
      }

      axiosIns(config)
        .then(function(response){
          if(response.status===200){
            yo.detalle_des_productos=response.data['response']
            console.log(yo.detalle_des_productos)
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loadingExcel = false
        });

    },

    registrarValoresUnitarios(){
      const yo=this
      var array=[];
      // console.log("ABCD")
      // console.log(this.valor_unitario1)
      // console.log(document.getElementById('cantidad_por_detalles1').innerHTML)

      for(let i=1; i<=this.detalle_des_productos.length;i++){
        var list=[];
        list[0]= document.getElementById('factura_f').value
        list[1]= document.getElementById('valor_unitario'+i).value
        list[2]= document.getElementById('cantidad_por_detalles'+i).innerHTML
        list[3]= document.getElementById('detalle_producto'+i).innerHTML
        list[4]= document.getElementById('precio_neto_unitario'+i).innerHTML
        list[5]= document.getElementById('variedad'+i).innerHTML
        list[6]= document.getElementById('numero_material'+i).innerHTML
        array.push(list)
      }


      // console.log(array)

      const data = JSON.stringify({
        'datos':array,
        'usuario': this.id_user
      })

      const config = {
        method: 'post',
        url: '/comex/holdco/registrar_nuevos_precios/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }

      axiosIns(config)
        .then(function(response){

          if(response.status===200){
            yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó correctamente.", 'success', 5000)
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Registro fallido',
                        icon: 'XIcon',
                        text: 'Ocurrió un error en el registro.',
                        variant: 'danger',
                      },
                    },
                    {
                      position: 'top-center',
                    })
        })
        .finally(function () {
          yo.traerFacturas();
          yo.mostrarModalEditar= false
        });


    },

    okModalEditar(bvModalEvt){
      bvModalEvt.preventDefault()

      this.registrarValoresUnitarios()
    },





    descargarFile() {
      const yo = this
      const spd = yo.items
      const arrayFInal = []

      spd.forEach(function (value) {
        let estd = "";
        if(value.estado==="0" || value.estado==="1"){
          estd = "Pendiente"
        }else if(value.estado==="2" || value.estado==="3" || value.estado==="4"){
          estd = "Devolución"
        }else if(value.estado==="5" || value.estado==="6" || value.estado==="7"){
          estd = "Descuento"
        }

        arrayFInal.push(
            {
              "id": value.id,
              "fecha_hora": value.fecha_hora,
              "dni": value.dni,
              "nombres": value.nombres,
              "cargo": value.cargo,
              "area": value.area,
              "codigo": value.codigo,
              "fecha_hora_cierre": value.fecha_hora_cierre,
              "observacion": value.observacion,
              "estado": estd,
              "firma": value.firma,
              "con_evaluador": value.con_evaluador.nombres + " " +value.con_evaluador.apellidos,
              "origen": value.origen,
            }
        )
      })

      if (spd.length > 0){
        const data = JSON.stringify(
            {
              "datas":arrayFInal,
            }
        )

        const config = {
          method: 'post',
          url: 'elli/llaves/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Reporte de Entrega de Llaves.xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loading_exp = false
            });

      }else{
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },

    // mostrarModalEditar(datos){
    //   const yo = this
    //   yo.estadoModalEditar = true

    // },

    // -.-.-.-.-.-.-.-.-..-.-.-

    resetModal() {
      this.id_editar = null
      document.getElementById('evento').value=''
      for(let i=1; i<=this.detalle_des_productos.length;i++){

        var list=[];
        document.getElementById('factura_f').value=''
        document.getElementById('valor_unitario'+i).value=''
        document.getElementById('cantidad_por_detalle'+i).innerHTML=''
        document.getElementById('detalle_producto'+i).innerHTML=''
        array.push(list)
      }
    },

    validacionEditar(bvModalEvt){
      bvModalEvt.preventDefault()
      this.editarEstado()
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.alinear-una-sola-linea{
  white-space: nowrap!important;
}

.tablita{
  min-height: 58vh!important;
}

.tablita::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablita::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablita::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

</style>
